import { render, staticRenderFns } from "./AuthAdmin.vue?vue&type=template&id=0775319f&"
import script from "./AuthAdmin.vue?vue&type=script&lang=js&"
export * from "./AuthAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports